import ApiBack from "../../../utils/domains/ApiBack";
import IPSView from "../../../models/ipsView";
import Municipio from "../../../models/municipio";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import ServicePrivate from "../../../services/ServicePrivate";
import { Button, Form, Modal } from "react-bootstrap";
import { MessageToastify } from "../../../utils/funtions/MessageToastify";
import { useForm } from "../../../utils/hooks/useForm";
import { jwtDecode } from "jwt-decode";
import { useRef } from "react";
import Deparment from "../../../models/Deparment";

export const ViewCreateMuni = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [process, setProcess] = useState<boolean>(false);
  const [arrayjIps, setArrayIps] = useState<IPSView[]>([]);
  const [proccess, setProccess] = useState<boolean>();
  const [showFinal, setShowFinal] = useState(false);
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  type formaHtml = React.FormEvent<HTMLFormElement>;
  const handleClose = () => setShow(false);
  const handleClose2 = () => setShow2(false);
  const formRef = useRef<HTMLFormElement>(null);
  const [arrayMunicipio, setArrayMunicipio] = useState<Municipio[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  //function to error the Token on the time, using when token is invalid or expired

  let { id, nombre_municipio, codigo_municipio, doubleLink, object } =
    useForm<Municipio>(
      new Municipio(0, "", "", new Deparment(0, "")) // Incluye `id_municipio` con un valor inicial
    );

  const [objips, setObjips] = useState<IPSView>(
    new IPSView(
      0,
      "",
      "",
      false,
      new Municipio(0, "", "", new Deparment(0, "")),
      new Date(),
      false,
      "", new Date(), true, true, "", ""
    )
  );

  const handleTokenError = () => {
    navigate("/"); // Go to login session
  };
  const getMunicipios = async () => {
    setLoading(true);
    try {
      const url = `${ApiBack.MUNICIPALITY_LIST}?page=${page}`;
      const results = await ServicePrivate.requestGET(url);
      setArrayMunicipio(results.results);
      setTotalItems(results.total_count);
      setTotalPages(results.total_pages);
    } catch (error) {
      console.error("Error fetching formats:", error);
      handleTokenError();
    } finally {
      setLoading(false);
    }
  };

  const updateSupportDetails = async (myipsid: number, isActive: boolean) => {
    setProccess(true);

    try {
      // Encuentra el soporte por ID en el array
      const updatedSupport = arrayjIps.find((myIps) => myIps.id === myipsid);

      if (!updatedSupport) {
        console.error("Soporte no encontrado");
        return;
      }

      // Crea un objeto con el valor de is_active basado en el parámetro
      const updatedObject = {
        is_active: isActive,
      };

      const urlUpdate = ApiBack.IPS_UPDATED + "/" + myipsid;
      const response = await ServicePrivate.requestPUT(
        urlUpdate,
        updatedObject
      );

      if (response.data.OK) {
        MessageToastify(
          "error",
          "Error en el momento de Actualizar el ID del usuario.",
          7000
        );
        getAllConsents();
      } else {
        MessageToastify("success", "ID actualizado del usuario.", 7000);
        setShowFinal(false);
        getAllConsents();
      }
    } catch (error) {
      console.error("Error actualizando el ID del usuario:", error);
      MessageToastify(
        "error",
        "Error en el momento de Actualizar el ID del usuario en el servidor.",
        7000
      );
      setShow(false);
    } finally {
      setProccess(false);
      setShow(false);
    }
  };

  const getAllConsents = async () => {
    try {
      const results = await ServicePrivate.requestGET(ApiBack.IPS_VIEW);
      if (results) {
        setArrayIps(results);
        setLoading(false);
      } else {
        setLoading(true);
      }
    } catch (error) {
      console.error("Error fetching consents:", error);
      const token = localStorage.getItem("access");
      if (token === null) {
        handleTokenError();
      }
    }
  };

  const sendForm = async (fh: formaHtml) => {
    try {
      fh.preventDefault();
      setProcess(true);
      const form = fh.currentTarget;

      form.classList.add("was-validated");

      if (form.checkValidity() === false) {
        fh.preventDefault();
        fh.stopPropagation();
        setProcess(false);
        MessageToastify(
          "error",
          "Por favor, completa todos los campos requeridos.",
          7000
        );
        return;
      }

      // Crear el objeto para enviar con los campos proporcionados
      const formData = {
        codigo_municipio: object.codigo_municipio,
        nombre_municipio: object.nombre_municipio,
      };
      console.log(formData);

      // Realizar la solicitud POST
      const response = await ServicePrivate.requestPOST(
        ApiBack.MUNICIPALITY_CREATE,
        formData
      );

      if (response.OK) {
        setProcess(false);
        MessageToastify("error", "error al momento de crear el soporte.", 7000);
      } else {
        setProcess(false);
        MessageToastify("success", "soporte creado", 7000);
        handleClose2();
        getMunicipios();
      }
    } catch (error) {
      setProcess(false);
      MessageToastify("error", "Error en el momento  crear el soporte.", 7000);
    }
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (page < totalPages) {
      setPage(page + 1);
    }
  };

  useEffect(() => {
    getAllConsents();
    getMunicipios();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);
  return (
    <>
      <div>
        <div className="row">
          <div className="page-header">
            <div className="col-lg-6 col-sm-12">
              <h3 className="page-title fs-3 fw-bold">
                <i className="fa-solid fa-users"></i>&nbsp;Municipio
              </h3>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb breadcrumb-chevron"></ol>
              </nav>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-lg-9 col-sm-12">
                    <div
                      className="pagination-info"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <h4 className="card-title fs-5">
                        <i className="fa-solid fa-list"></i>&nbsp;Listado
                      </h4>
                      <p className="boldText">
                        Total de municipios en esta página:{" "}
                        <b className="fw-bold fs-6">{arrayMunicipio.length}</b>
                      </p>
                      <p className="boldText">
                        Total de municipios:{" "}
                        <b className="fw-bold fs-6">{totalItems}</b>
                      </p>
                      <p className="boldText">
                        Total de páginas:{" "}
                        <b className="fw-bold fs-6">{totalPages}</b>
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-12">
                    <div className="d-flex justify-content-end">
                      <button
                        className={
                          "badge fs-6 py-1 pe-2 text-success-emphasis bg-success-subtle border border-success-subtle rounded-pill"
                        }
                        type="button"
                        onClick={() => setShow2(true)}
                        style={{ marginLeft: "10px" }}
                      >
                        <i className="fa-solid fa-plus"></i>&nbsp;Crear
                      </button>
                    </div>
                  </div>
                </div>

                <div className="row d-flex"></div>
                <div className="table-responsive">
                  <table className="table table-striped table-sm rounded-table">
                    <thead className="table-dark">
                      <tr>
                        <th>Nombre municipio</th>
                        <th>Código municipio</th>
                      </tr>
                    </thead>
                    <tbody className="table-group-divider">
                      {arrayMunicipio.map((myIps, count) => (
                        <tr key={count + 1}>
                          <td>{myIps.nombre_municipio}</td>
                          <td>{myIps.codigo_municipio}</td>
                          {/* <td>
                            <p>
                              <button
                                className={
                                  myIps.is_active
                                    ? "badge fs-6 py-1 pe-2 text-danger-emphasis bg-danger-subtle border border-danger-subtle rounded-pill"
                                    : "badge fs-6 py-1 pe-2 text-success-emphasis bg-success-subtle border border-success-subtle rounded-pill"
                                }
                                type="button"
                                onClick={() => getOneIps(myIps.id)}
                                style={{ marginLeft: "10px" }}
                              >
                                {myIps.is_active ? (
                                  <>Inactivar</>
                                ) : (
                                  <>Activar</>
                                )}
                              </button>
                            </p>
                          </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="d-flex align-items-center justify-content-center m-3">
                    <nav className="d-flex align-items-center justify-content-center">
                      <button
                        className="badge fs-6 p-3 pe-2 px-2 text-primary-emphasis bg-primary-subtle border border-primary-subtle rounded-pill"
                        onClick={handlePreviousPage}
                        disabled={page === 1}
                      >
                        <i className="fa-solid fa-arrow-left"></i>&nbsp;Anterior
                      </button>
                      <span className="fs-6">
                        &nbsp;Página {page} de {totalPages}&nbsp;
                      </span>
                      <button
                        className="badge fs-6 p-3 pe-2 px-2 text-primary-emphasis bg-primary-subtle border border-primary-subtle rounded-pill"
                        onClick={handleNextPage}
                        disabled={page === limit}
                      >
                        Siguiente&nbsp;
                        <i className="fa-solid fa-arrow-right"></i>
                      </button>
                    </nav>
                  </div>
                </div>

                <Modal
                  show={show}
                  onHide={handleClose}
                  backdrop="static"
                  keyboard={false}
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title className="text-center fw-bold">
                      <i className="fa-regular fa-circle-xmark"></i>
                      &nbsp;Desactivar la ips
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    ¿Realmente desea cambiar el estado de la ips?
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => {
                        setShow(false);
                      }}
                    >
                      <i className="fa-solid fa-backward"></i>
                      &nbsp;Cancelar
                    </Button>
                    <Button
                      variant="success"
                      onClick={() => {
                        console.log("ID de la ips:", id);
                        updateSupportDetails(objips.id, !objips.is_active);
                      }}
                    >
                      Confirmar
                    </Button>
                  </Modal.Footer>
                </Modal>

                <Modal
                  show={show2}
                  onHide={handleClose2}
                  backdrop="static"
                  keyboard={false}
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title className="text-center fw-bold">
                      <i className="fa-solid fa-folder-plus"></i>
                      &nbsp;Formulario de creación
                    </Modal.Title>
                  </Modal.Header>
                  <Form
                    className="forms-sample"
                    validated={process}
                    onSubmit={sendForm}
                    noValidate
                    ref={formRef}
                  >
                    <Modal.Body>
                      {/* Campo para nombre_ips */}
                      <Form.Group controlId="nombre_ips" className="mb-3 w-100">
                        <Form.Label
                          className="fw-bold mb-2 mt-2"
                          htmlFor="nombre_ips"
                        >
                          Nombre del municipio:
                        </Form.Label>
                        <Form.Control
                          required
                          type="text"
                          name="nombre_municipio"
                          className="form-control"
                          id="nombre_municipio"
                          placeholder="Escriba el nombre de la IPS"
                          value={nombre_municipio}
                          onChange={(e) => {
                            let value = e.target.value.toUpperCase(); // Convierte a mayúsculas
                            // Validar que solo contenga letras y limitar a 60 caracteres
                            if (
                              /^[A-Za-z\s]*$/.test(value) &&
                              value.length <= 60
                            ) {
                              e.target.value = value; // Establece el valor en mayúsculas
                              doubleLink(e); // Llama a tu función existente
                            }
                          }}
                          autoComplete="off"
                          maxLength={60} // Limita a 60 caracteres
                        />
                        <Form.Control.Feedback type="invalid">
                          Nombre del municipio es obligatorio.
                        </Form.Control.Feedback>
                      </Form.Group>

                      {/* Campo para cod_ips */}
                      <Form.Group controlId="cod_ips" className="mb-3 w-100">
                        <Form.Label
                          className="fw-bold mb-2 mt-2"
                          htmlFor="cod_ips"
                        >
                          Código del municipio:
                        </Form.Label>
                        <Form.Control
                          required
                          type="text"
                          name="codigo_municipio"
                          className="form-control"
                          id="codigo_municipio"
                          placeholder="Escriba el código de la IPS"
                          value={codigo_municipio}
                          onChange={(e) => {
                            const value = e.target.value;
                            // Permitir solo números y limitar a 20 caracteres
                            if (/^\d*$/.test(value) && value.length <= 20) {
                              doubleLink(e); // Llama a tu función existente
                            }
                          }}
                          autoComplete="off"
                          maxLength={20} // Limita a 20 caracteres
                        />
                        <Form.Control.Feedback type="invalid">
                          Código del municipio es obligatorio.
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="success" onClick={handleClose2}>
                        <i className="fa-solid fa-backward"></i>&nbsp;Cancelar
                      </Button>
                      <Button
                        variant="success"
                        type="submit"
                        onClick={() => { }}
                      >
                        <i className="fa-solid fa-plus"></i>&nbsp;Guardar
                      </Button>
                    </Modal.Footer>
                  </Form>
                  <ToastContainer />
                </Modal>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};
